import { api } from '@/lib/api'

/** @typedef {import('@/types/api').PosPackageCatalogItem} PosPackageCatalogItem */
/** @typedef {import('@/types/api').Sale} Sale */
/** @typedef {import('@/types/api').SaleLine} SaleLine */

/**
 * @returns {Promise<PosPackageCatalogItem[]>}
 */
export async function fetchPosPackageCatalog() {
  const { data } = await api.get('/packages/pos-catalog')
  return data.data.packages
}

/**
 * @param {number} saleId
 * @param {{ package_id: number, recipient_name?: string, notes?: string }} payload
 * @returns {Promise<{ line: SaleLine, sale: Sale }>}
 */
export async function addSalePackageLine(saleId, payload) {
  const { data } = await api.post(`/sales/${saleId}/package-lines`, payload)
  return {
    line: data.data.line,
    sale: data.data.sale,
  }
}

/**
 * @param {number} customerId
 * @param {number} [saleId]
 * @returns {Promise<import('@/types/api').PosRedeemablePackage[]>}
 */
export async function fetchRedeemablePackages(customerId, saleId) {
  const params = saleId ? { sale_id: saleId } : undefined
  const { data } = await api.get(`/customers/${customerId}/redeemable-packages`, { params })
  return data.data.packages
}

/**
 * @param {number} customerId
 * @returns {Promise<import('@/types/api').PosCustomerPackageBalance[]>}
 */
export async function fetchCustomerPackageBalances(customerId) {
  const { data } = await api.get(`/customers/${customerId}/package-balances`)
  return data.data.packages
}

/**
 * @param {number} saleId
 * @param {{ customer_package_id: number, service_id: number, stylist_id?: number | null }} payload
 * @returns {Promise<{ line: import('@/types/api').SaleLine, sale: import('@/types/api').Sale }>}
 */
export async function addSaleRedeemLine(saleId, payload) {
  const { data } = await api.post(`/sales/${saleId}/redeem-lines`, payload)
  return {
    line: data.data.line,
    sale: data.data.sale,
  }
}

/**
 * @param {number} saleId
 * @param {{ customer_package_id: number, service_ids: number[], stylist_id?: number | null }} payload
 * @returns {Promise<{ lines: import('@/types/api').SaleLine[], sale: import('@/types/api').Sale }>}
 */
export async function addSaleRedeemLines(saleId, payload) {
  const { data } = await api.post(`/sales/${saleId}/redeem-lines/batch`, payload)
  return {
    lines: data.data.lines,
    sale: data.data.sale,
  }
}
